export class FetchNotifications {
  static readonly type = '[Notifications] Fetch Notifications';
}

export class RespondToNotification {
  static readonly type = '[Notifications] Respond To Notification';
  constructor(public notificationId: number, public responseId: number, public textResponse?: string) {}
}

export class UpdateNotifications {
  static readonly type = '[Notifications] Update Notifications';
}

export class SetCgm90Enrollment {
  static readonly type = '[Notifications] Set CGM90 enrollment';
  constructor(public notificationId: number, public consented: boolean) {}
}
